import jQuery from 'jquery';
import { oneLine } from 'common-tags';
import { ABTest } from '@shared/abtest';
import { T_ } from '@shared/translation';
import { removeError, addError } from '@shared/form-tools';
import { getUserIdfromCookie, getCSRFToken } from '@shared/cookie';
import LoginSignup from '@shared/modal-login-signup';
import { tagsSessionId } from '@shared/threatmetrix';
import Modal from '@shared/ui-modal';
import 'bootstrap';

let facebookJsIncluded;
let allowSignup = true;
const bsPage = true;
let fbtoken;
let loginAjax;
let profileModal;
let openidGotoUrl;
let prevUsernameCheckReq;
let prevEmailCheckReq;
let validUsername;
let validEmail = true;
let onFacebookLoginCallback;

export function setFacebookLoginCallback(callback) {
  onFacebookLoginCallback = callback;
}
// var contacts;

function facebookVerifyLoginStatus() {
  if (typeof FB === 'undefined' || typeof FB.getLoginStatus === 'undefined') {
    return;
  }
  FB.getLoginStatus(response => {
    if (response.status != 'connected') {
      return;
    }
    // dirtory inline hireme form
    if (
      jQuery('.quick-hire-post-form').length > 0 &&
      jQuery('.quick-hire-post-form').is(':visible')
    ) {
      jQuery('.quick-hire-post-form').trigger('integrateForm');
      // fetch large facebook picture
      showProfileDetails(true);
    } else {
      // fetch normal facebook picture
      showProfileDetails(false);
    }
    facebookRedirect();
  }, true);
  // additional parameter 'true' must be passed to retrieve a new signed
  // request
}

function showProfileDetails(large) {
  if (window.location.hash.indexOf('#profile-update-shown') >= 0) {
    profileModal = true;
  }

  if (typeof profileModal !== 'undefined') {
    jQuery('#signup-modal').trigger('moveFBidentifierToProfileModal');
  }

  jQuery('#fb_signup_welcome').hide();
  jQuery('#fb_link_welcome').hide();
  jQuery('#fb_error_title').hide();
  jQuery('#fb_login_welcome').show();

  if (typeof FB === 'undefined' || typeof FB.api === 'undefined') {
    return;
  }

  if (large) {
    FB.api('/me/picture?type=large', response => {
      jQuery('#fb_profile_pic').css(
        'background',
        `url('${response.data.url}') no-repeat center`,
      );
      jQuery('#fb_profile_pic').show();
    });
  } else {
    FB.api('/me/picture?type=normal', response => {
      jQuery('#fb_profile_pic').css(
        'background',
        `url('${response.data.url}') no-repeat center`,
      );
      jQuery('#fb_profile_pic').show();
    });
  }

  FB.api('/me', { fields: 'first_name' }, response => {
    jQuery('.fb_fullname').html(response.first_name);
  });
}

function facebookRedirect() {
  if (loginAjax) {
    return false;
  }

  openidGotoUrl = jQuery('#login_goto_id').val();
  const partnerInput = jQuery('#partner').val();
  // var token = jQuery('#token').val();
  const url = '/users/facebook/onLogin.php';

  center(jQuery('#fb_popup_window'), jQuery('.loggedout_header').offset());
  let loginBoxOffset = jQuery('.loggedout_header').offset();
  if (!loginBoxOffset) {
    loginBoxOffset = Object();
    loginBoxOffset.top = 0;
    loginBoxOffset.left = 0;
  }

  jQuery('#popup_background').css('top', `-${loginBoxOffset.top}px`);
  jQuery('#popup_background').css('left', `-${loginBoxOffset.left}px`);

  jQuery('#popup_background').css('width', jQuery(document).width());
  jQuery('#popup_background').css('height', jQuery(document).height());

  jQuery('.fb_div').hide();
  jQuery('#fb_loading').show();
  if (
    jQuery('.quick-hire-post-form').length === 0 ||
    !jQuery('.quick-hire-post-form').is(':visible')
  ) {
    jQuery('body').addClass('modal-open');
    jQuery('#fb_popup').removeClass('hide');
  }
  loginAjax = jQuery.ajax({
    type: 'POST',
    dataType: 'json',
    url,
    data: {
      action: 'connect',
      auto_link: 1,
      decode: 1,
      goto_url: openidGotoUrl,
      partner: partnerInput,
      csrf_token: getCSRFToken(),
    },

    success(result) {
      loginAjax = false;
      jQuery('#fb_loading').hide();
      jQuery('.fb_submit_loading').hide();
      jQuery('#fbSignupBtn').show();
      jQuery('.fbLinkBtn').show();
      removeError(jQuery('#fb_user'), true);
      defreezeForm();

      if (result.status == 'successful') {
        if (result.retAction == 'signup') {
          jQuery('#fb_email').html(result.email);
          jQuery('#fb_user').val(result.availableName);
          checkUsernameExist(jQuery('#fb_user').val());
          jQuery('#signupRadioBtns').show();
          jQuery('#fb_signup').show();
          jQuery('[value=fb_signup]')
            .parent()
            .parent()
            .click();
          jQuery('#signupRadioBtns').show();
          jQuery('#fb_login_welcome').hide();
          jQuery('#fb_signup_welcome').show();

          jQuery('#fb_currency').val(result.currency);
          jQuery('#fb_timezone').val(result.timezone);
          if (result.promptEmail === true) {
            jQuery('#fb_email_div').hide();
            document
              .getElementById('fb_email_input_div')
              .classList.remove('is-hidden');
            validEmail = false;
          }
          fbtoken = result.token;
        } else if (result.retAction == 'link') {
          jQuery('#fb_login_welcome').hide();
          jQuery('#signupRadioBtns').hide();
          jQuery('#fb_link_welcome').show();
          jQuery('#linkUser').html(result.username);
          jQuery('#fb_link_email').html(result.email);
          jQuery('#fb_link_user_display').html(result.username);
          jQuery('#fb_link_user').val(result.username);
          jQuery('#fb_link').show();
          fbtoken = result.token;
        } else if (
          jQuery('.quick-hire-post-form').length > 0 &&
          jQuery('.quick-hire-post-form').is(':visible')
        ) {
          // directory inline hireme form
          jQuery('.quick-hire-post-form').trigger('welcomeFacebook', [
            false,
            getUserDetails,
          ]);
        } else {
          // login successfully
          jQuery('#fb_login_status').html('Logging in...');
          jQuery('#fb_login_welcome').show();
          jQuery('#fb_loading').show();
          if (isOnNotRedirectPage()) {
            if (typeof onFacebookLoginCallback === 'function') {
              onFacebookLoginCallback();
            }
            getUserDetails(false);
            jQuery('[class="container_bottom_newuser"]').remove();
          } else {
            if (typeof payPalOfferFreeFeatured !== 'undefined') {
              // this var is defined in coupon/paypal/paypaloffer_signup.htm
              window.location.reload();
              return false;
            }
            if (window.location.pathname == '/invite/') {
              window.location = '/invite/?showFacebook';
              return false;
            }

            // Null openid_goto_url
            if (!openidGotoUrl) {
              window.location.reload();
              return false;
            }
            window.location.href = result.url;
          }
        }
      } else if (result.status == 'failed') {
        if (result.reason == 'FBAuth') {
          jQuery('#fb_login_welcome').hide();
          jQuery('#fb_error_title')
            .text(result.long_reason)
            .show();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (result.reason == 'userExists') {
          jQuery('#fb_login_welcome').hide();
          jQuery('#fb_error_title').html(result.error_title);
          jQuery('#fb_error_content').html(result.long_reason);
          jQuery('#fb_error_title').show();
          jQuery('#fb_error_div').show();
        } else if (result.type == 'SUSPENDED') {
          // the user is suspended
          jQuery('body').removeClass('modal-open');
          jQuery('#fb_popup').addClass('hide');
          window.location.href = '/users/usersuspended.php';
        } else {
          alert(result.reason);
        }
      }

      return false;
    },
  });
  return false;
}

function getUserDetails(isNewUser, callback) {
  jQuery.ajax({
    type: 'get',
    dataType: 'json',
    url: '/ajax/postproject/userdetails.php',
    success(response) {
      if (response.status == 'success') {
        if (typeof callback !== 'undefined') {
          callback(isNewUser, response);
        } else {
          const logoHTML =
            `<img src='${response.logo_url}' ` +
            `alt='${response.logoname}' ` +
            'border=0 width=80 height=80 ' +
            "style='margin-right: 20px;'>";
          jQuery('#loggedinLogo').html(logoHTML);
          jQuery('#loggedinFullname').html(response.name);
          jQuery('body').removeClass('modal-open');
          jQuery('#fb_popup').addClass('hide');

          jQuery('#projectUserSelect').fadeOut('slow', () => {
            jQuery('#projectUserSelect').remove();
          });
          jQuery('#fbConnect').fadeOut('slow', () => {
            jQuery('#fbConnect').remove();
          });
          jQuery('#loginFl').fadeOut('slow');
          jQuery('#default-header #user-login').fadeOut('slow', () => {
            if (isNewUser) {
              // hide 'back'
              jQuery('#loggedinFullname')
                .parent()
                .html(
                  jQuery('#loggedinFullname')
                    .parent()
                    .html()
                    .replace('back', ''),
                );
            }
          });

          // This is code specific to users of user_auth_form.js
          // It is here for the moment since user_auth_form.js
          // needs flapi and flapi will be deprecated
          if (jQuery('#nonAuthForm').length) {
            jQuery('#nonAuthForm').fadeOut('slow');
          }

          jQuery('#headerTopLoggedIn').fadeIn('slow');
        }
      }
    },
  });
}

function isOnNotRedirectPage() {
  if (
    window.location.pathname == '/post-project' ||
    window.location.pathname == '/buyers/onverifycreate.php' ||
    window.location.pathname == '/contest/create.php'
  ) {
    return true;
  }

  return false;
}

function center(element, referenceOffset) {
  if (!referenceOffset) {
    referenceOffset = Object();
    referenceOffset.top = 0;
    referenceOffset.left = 0;
  }

  element.css('position', 'absolute');
  const top =
    ((jQuery(window).height() - element.outerHeight()) / 2 -
      referenceOffset.top) *
      0.5 +
    jQuery(window).scrollTop();
  const left =
    (jQuery(window).width() - element.outerWidth()) / 2 +
    jQuery(window).scrollLeft() -
    referenceOffset.left;
  element.css('top', `${top}px`);
  element.css('left', `${left}px`);
}

function onAccept() {
  if (getUserIdfromCookie() === '') {
    if (window.self != window.top) {
      window.top.location.href = `${window.location.href}#showsignup`;
      return true;
    }
  } else {
    // user is logged in
    window.top.location.href = `${window.location.protocol}//${
      window.location.host
    }/dashboard/`;
    return true;
  }
  onFBLogin();
}

function onFBLogin() {
  // shutting down the original login modal if open
  jQuery('#header-login-modal').modal('hide');

  if (
    typeof FB === 'undefined' ||
    typeof FB.getLoginStatus === 'undefined' ||
    typeof FB.Event === 'undefined' ||
    typeof FB.Event.subscribe === 'undefined' ||
    typeof FB.login === 'undefined'
  ) {
    return;
  }

  FB.getLoginStatus(response => {
    if (response.status != 'connected') {
      // FB.Event.subscribe('auth.statusChange', () => {
      //   facebookVerifyLoginStatus();
      // });

      FBLoginWithReverify();
    } else {
      FB.api('/me/permissions', response => {
        if (
          response.data &&
          response.data.find(
            data => data.permission === 'email' && data.status === 'granted',
          )
        ) {
          facebookVerifyLoginStatus();
        } else {
          FBLoginWithReverify(true);
        }
      });
    }
  });
}

function FBLoginWithReverify(rerequest = false) {
  const opts = { scope: 'email', return_scopes: true };
  if (rerequest) {
    opts.auth_type = 'rerequest';
  }

  FB.login(response => {
    if (response.status === 'connected') {
      if (!isEmailInScope(response)) {
        showErrorModal();
      } else {
        facebookVerifyLoginStatus();
      }
    }
  }, opts);
}

let errorModal;

function showErrorModal() {
  if (!errorModal) {
    errorModal = new Modal('errorModal', {
      header: "<h6>We couldn't get your email address</h6>",
      body:
        'To complete your login with Facebook, we need your email address. ' +
        'Please click continue and allow this permission.',
      footer:
        '<button id="close-error-modal" class="btn btn-plain">Close</button>' +
        '<button id="continue-error-modal" class="btn btn-success Modal-controls-primary">Continue</button>',
    });
    document
      .getElementById('errorModal')
      .getElementsByClassName('Modal-footer')[0]
      .classList.add('Modal-footer--right');
    document
      .getElementById('close-error-modal')
      .addEventListener('click', () => {
        errorModal.hide();
      });
    document
      .getElementById('continue-error-modal')
      .addEventListener('click', () => {
        errorModal.hide();
        // if user does not allow email, reverify
        FBLoginWithReverify(true);
      });
  }
  errorModal.show();
}

function isEmailInScope(response) {
  return response.authResponse.grantedScopes.match(new RegExp('email'));
}

export function checkFBPostPermission(callback) {
  if (
    typeof FB === 'undefined' ||
    typeof FB.api === 'undefined' ||
    typeof FB.login === 'undefined'
  ) {
    return;
  }

  FB.api('/me/permissions', pResponse => {
    if (
      typeof pResponse !== 'object' ||
      typeof pResponse.data !== 'object' ||
      typeof pResponse.data[0] !== 'object'
    ) {
      FB.login(
        () => {
          window.location = '/invite/?showFacebook';
        },
        { scope: 'email' },
      );
    } else {
      callback();
    }
  });
}

function hasChosenLookingForOption() {
  if (
    !jQuery('#fb_looking_to_hire').is(':checked') &&
    !jQuery('#fb_looking_for_work').is(':checked')
  ) {
    jQuery('#fb_looking_for_label')
      .parent('.control-group')
      .addClass('error');
    jQuery('#fb_looking_to_hire')
      .closest('label')
      .addClass('error');
    jQuery('#fb_looking_for_work')
      .closest('label')
      .addClass('error');
    return false;
  }

  jQuery('#fb_looking_for_label')
    .parent('.control-group')
    .removeClass('error');
  jQuery('#fb_looking_to_hire')
    .closest('label')
    .removeClass('error');
  jQuery('#fb_looking_for_work')
    .closest('label')
    .removeClass('error');
  return true;
}

function checkUsernameExist(username) {
  if (!bsPage) {
    jQuery('#chk_username_exist').hide();
  }
  if (prevUsernameCheckReq) {
    prevUsernameCheckReq.abort();
  }
  if (!needShowUsernameErrorMsg()) {
    validUsername = false;
    let useJSON = false;
    if (bsPage) {
      useJSON = true;
    }
    return jQuery.ajax({
      url:
        '/ajax/check-username-exist.php?' +
        `username=${username}&json=${useJSON}`,
      dataType: 'json',
      success(msg) {
        if (/exists/i.test(msg.msg)) {
          validUsername = false;
          jQuery('#chk_username_exist').html(msg.msg);
          if (bsPage) {
            jQuery('#chk_username_exist')
              .closest('.form-step')
              .removeClass('success is-valid')
              .addClass('error is-invalid');
          } else {
            jQuery('#chk_username_exist')
              .removeClass('ns_success-msg')
              .addClass('ns_error');
          }

          jQuery('#chk_username_exist').show();
        } else {
          validUsername = true;
          jQuery('#chk_username_exist').html(msg.msg);
          if (bsPage) {
            jQuery('#chk_username_exist')
              .closest('.form-step')
              .removeClass('error is-invalid')
              .addClass('success is-valid');
          } else {
            jQuery('#chk_username_exist')
              .removeClass('ns_error')
              .addClass('ns_success-msg');
          }

          jQuery('#chk_username_exist').show();
        }
      },
    });
  }

  validUsername = false;
  return false;
}

function needShowUsernameErrorMsg() {
  if (
    jQuery('#fb_user').length !== 0 &&
    jQuery('input[name=connect_type][value=fb_signup]:radio').is(':checked')
  ) {
    const pattern = /^[a-z][a-z0-9]{2,15}$/i;
    if (!pattern.test(jQuery('#fb_user').val())) {
      if (!bsPage) {
        addError(
          jQuery('#fb_user'),
          'Enter 3-16 alphanumeric characters [a-z 0-9] ' +
            'starting with a letter',
        );
      } else {
        jQuery('#chk_username_exist')
          .html(
            'Enter 3-16 alphanumeric ' +
              'characters [a-z 0-9] starting with a letter',
          )
          .show();
        jQuery('#chk_username_exist')
          .closest('.form-step')
          .addClass('error is-invalid')
          .removeClass('success is-valid');
      }
      return true;
    } else if (jQuery('#fb_user').hasClass('ns_error')) {
      return true;
    }

    if (!bsPage) {
      removeError(jQuery('#fb_user'), true);
    } else {
      jQuery('#chk_username_exist').html('Valid username');
      jQuery('#chk_username_exist')
        .closest('.form-step')
        .addClass('success is-valid')
        .removeClass('error is-invalid')
        .show();
    }
    return false;
  }
  return false;
}

function checkEmailValid(email) {
  validEmail = false;
  if (email.length === 0) {
    if (!bsPage) {
      addError(jQuery('#fb_email_input'), 'Please enter your email address.');
    } else {
      jQuery('#fb_email_input')
        .html('Please enter your email address')
        .show();
      jQuery('#fb_email_input')
        .closest('.form-step')
        .addClass('is-invalid')
        .removeClass('is-valid');
    }
    return false;
  }
  const pattern = new RegExp(
    '^([\\w\\-\\+!#%\\*\\=\\?\\^\\{\\}\\|~]+' +
      '(?:\\.[\\w\\-\\+!#%\\*\\=\\?\\^\\{\\}\\|~]+)*)' +
      '@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,10}(?:\\.[a-z]{2})?)$',
    'i',
  );
  if (!pattern.test(email)) {
    if (!bsPage) {
      addError(
        jQuery('#fb_email_input'),
        'Please enter a valid email address.',
      );
    } else {
      jQuery('#chk_valid_email')
        .html('Please enter a valid email address.')
        .show();
      jQuery('#chk_valid_email')
        .closest('.form-step')
        .addClass('is-invalid')
        .removeClass('is-valid');
      return;
    }
  } else if (jQuery('#fb_email_input').hasClass('ns_error')) {
    return;
  }
  if (prevEmailCheckReq) {
    prevEmailCheckReq.abort();
  }

  prevEmailCheckReq = jQuery.ajax({
    url: `/ajax/check-email-blocked.php?email=${encodeURIComponent(email)}`,
    dataType: 'json',
    success(isNotBlocked) {
      if (!isNotBlocked) {
        jQuery('#chk_valid_email').html(
          'This email domain is blocked. Please use a different email address.',
        );
        if (bsPage) {
          jQuery('#chk_valid_email')
            .closest('.form-step')
            .removeClass('success is-valid')
            .addClass('error is-invalid');
        } else {
          jQuery('#chk_valid_email')
            .removeClass('ns_success-msg')
            .addClass('ns_error');
        }

        return;
      }
      prevEmailCheckReq = jQuery.ajax({
        url: `/ajax/check-email-exist.php?email=${encodeURIComponent(
          email,
        )}&json=true`,
        dataType: 'json',
        success(response) {
          if (response.result !== 'success') {
            jQuery('#chk_valid_email').html(`${response.msg}.`);
            if (bsPage) {
              jQuery('#chk_valid_email')
                .closest('.form-step')
                .removeClass('success is-valid')
                .addClass('error is-invalid');
            } else {
              jQuery('#chk_valid_email')
                .removeClass('ns_success-msg')
                .addClass('ns_error');
            }
          } else {
            jQuery('#chk_valid_email').html('Valid Email Address');
            validEmail = true;
            if (!bsPage) {
              removeError(jQuery('#fb_email_input'), true);
            } else {
              jQuery('#chk_valid_email').html('Valid Email Address');
              jQuery('#chk_valid_email')
                .closest('.form-step')
                .addClass('is-valid')
                .removeClass('is-invalid')
                .show();
            }
          }
        },
      });
    },
  });
}

function freezeForm() {
  jQuery('[name=connect_type]').each(function() {
    jQuery(this).attr('disabled', '');
  });
}

function defreezeForm() {
  jQuery('[name=connect_type]').each(function() {
    jQuery(this).removeAttr('disabled');
  });
}

if (typeof facebookJsIncluded === 'undefined') {
  facebookJsIncluded = true;

  window.fbAsyncInitLoadError = () => {
    // The FB SDK load errored out. Might be Firefox Private Browsing. Disable
    // the button.
    jQuery(document).on('click', '.gaf-fb-connected-button', () => {
      jQuery('.gaf-fb-connected-button').text(
        oneLine`Facebook login is
        unavailable at the moment.`,
      );
      jQuery('.gaf-fb-connected-button').attr('disabled', 'disabled');
    });
  };

  window.fbAsyncInit_pinky = () => {
    if (typeof window.fbAsyncInit_pinky_run === 'undefined') {
      window.fbAsyncInit_pinky_run = true;

      jQuery(document)
        .off('click', '#header-fb-login', onFBLogin)
        .on('click', '#header-fb-login', onFBLogin);
      /* Now that we have removed redundant references to the old
             * facebook-connect.js we need to add handlers to the existing
             * buttons */
      jQuery(document)
        .off('click', '.gaf-fb-connected-button', onFBLogin)
        .on('click', '.gaf-fb-connected-button', onFBLogin);
      jQuery(document)
        .off('click', '.gaf-fb-login-button', onFBLogin)
        .on('click', '.gaf-fb-login-button', onFBLogin);
      jQuery(document)
        .off('click', '.gaf-fb-accept-button', onAccept)
        .on('click', '.gaf-fb-accept-button', onAccept);

      if (
        typeof FB === 'undefined' ||
        typeof FB.getLoginStatus === 'undefined'
      ) {
        return;
      }

      const FBLoginStatus = FB.getLoginStatus(e => {
        if (e.status == 'connected' || e.status == 'not_authorized') {
          return true;
        }

        return false;
      });
      if (FBLoginStatus) {
        jQuery('#fb_facepie').show();
      }
    }
  };

  if (window.fbinit_run) {
    window.fbAsyncInit_pinky();
  }

  // Trigger Signup Modal if the page comes from Facebook
  if (window.location.hash.substring(1) == 'showsignup') {
    setTimeout(onFBLogin(), 500);
  }
  jQuery(document).on('change', '[name=connect_type]', function() {
    jQuery('[name=connect_type]').attr('checked', '');
    jQuery(this).attr('checked', 'checked');
    jQuery('.connect_div').hide();
    jQuery(`#${jQuery(this).val()}`).show();
  });

  /* only for bootstrap page start */
  jQuery(document).on('click', '.close-fb-modal-bs', () => {
    jQuery('body').removeClass('modal-open');
    jQuery('#fb_popup').addClass('hide');
  });

  jQuery(document).on(
    'focus',
    '#fb_login_user, #fb_login_passwd, #fb_login_btn',
    () => {
      jQuery('.link-account-error')
        .html('')
        .hide();
    },
  );

  const defaultLookingFor = jQuery('#fb_popup .looking_for').data('default');
  const hideLookingForOption =
    jQuery.inArray(defaultLookingFor, ['Employer', 'Worker']) > -1;

  if (hideLookingForOption) {
    jQuery('#fb_looking_for_label').hide();
    jQuery('#fb_popup div.looking_for').hide();
  }

  if (defaultLookingFor === 'Employer') {
    jQuery('#fb_looking_to_hire').attr('checked', 'checked');
    jQuery('#fb_looking_for_work').attr('checked', false);
  } else if (defaultLookingFor === 'Worker') {
    jQuery('#fb_looking_to_hire').attr('checked', false);
    jQuery('#fb_looking_for_work').attr('checked', 'checked');
  }

  jQuery('#fb_looking_to_hire, #fb_looking_for_work').click(() => {
    hasChosenLookingForOption();
  });

  jQuery('.fbCloseBtn').click(() => {
    jQuery('body').removeClass('modal-open');
    jQuery('#fb_popup').addClass('hide');
    return false;
  });

  jQuery('.fbLinkBtn').click(function(e) {
    // Is it the login button? Then get the username and password
    // from the login forms. Otherwise get the username and password
    // from the link form.
    const url = '/users/facebook/onLink.php';
    let username;
    let passwd;
    if (
      e.target.id === 'fb_login_btn' ||
      e.target.id === 'fb_link_account_btn'
    ) {
      username = jQuery('#fb_login_user').val();
      passwd = jQuery('#fb_login_passwd').val();
    } else {
      username = jQuery('#fb_link_user').val();
      passwd = jQuery('#fb_link_passwd').val();
    }

    jQuery.ajax({
      type: 'POST',
      dataType: 'json',
      url,
      data: {
        auto_link: 1,
        decode: 1,
        goto_url: openidGotoUrl,
        username,
        passwd: encodeURI(passwd),
        token: fbtoken,
        importPic: jQuery('#fb_link').data('importPic'),
      },
      success(result) {
        if (result.status == 'success') {
          if (window.location.pathname == '/signup') {
            window.location = '/dashboard/';
          } else if (window.location.pathname == '/invite/') {
            window.location = '/invite/?showFacebook';
          } else if (
            jQuery('.quick-hire-post-form').length > 0 &&
            jQuery('.quick-hire-post-form').is(':visible')
          ) {
            // directory inline hireme form
            jQuery('.quick-hire-post-form').trigger('welcomeFacebook', [
              false,
              getUserDetails,
            ]);
          } else if (
            window.location.pathname == '/sellers/profile-update.php'
          ) {
            jQuery.ajax({
              url: '/sellers/profile-update.php',
              type: 'GET',
              dataType: 'json',
              data: 'ajax=1&PicImported=1',
              success(resp) {
                if (resp.status == 'success') {
                  // var profileUpdateAjaxJSON = resp.data;
                  jQuery('#profile-update-placeholder').trigger('reRender');
                  jQuery('.fb-bs-identifier').fadeOut('slow', () => {
                    jQuery('.fb-bs-identifier').remove();
                  });
                } else {
                  window.location = '/sellers/profile-update.php?PicImported=1';
                }
              },
              error() {
                window.location = '/sellers/profile-update.php?PicImported=1';
              },
            });
          } else if (typeof profileModal !== 'undefined') {
            jQuery.ajax({
              url: '/sellers/profile-update.php',
              type: 'GET',
              dataType: 'json',
              data: 'ajax=1&PicImported=1',
              success(resp) {
                if (resp.status == 'success') {
                  // var profileUpdateAjaxJSON = resp.data;
                  jQuery('#profile-update-placeholder').trigger('reRender');
                  jQuery('.fb-bs-identifier').fadeOut('slow', () => {
                    jQuery('.fb-bs-identifier').remove();
                  });
                  jQuery('#profile-update-placeholder').trigger(
                    'checkProfilePicture',
                  );
                } else {
                  window.location.reload();
                }
              },
              error() {
                window.location.reload();
              },
            });
          } else if (isOnNotRedirectPage()) {
            jQuery('#fb_signup_welcome').hide();
            jQuery('#fb_link_welcome').hide();
            jQuery('#fb_login_status').html('Logging in...');
            jQuery('#fb_login_welcome').show();

            getUserDetails(false);
            jQuery('[class="container_bottom_newuser"]').remove();
          } else if (result.url) {
            if (typeof payPalOfferFreeFeatured !== 'undefined') {
              window.location.reload();
              return false;
            }

            window.location.href = result.url;
          } else {
            window.location.reload();
          }
        } else if (/different Facebook/i.test(result.reason)) {
          if (isOnNotRedirectPage()) {
            jQuery('#fb_link_welcome').hide();
            jQuery('#fb_signup_welcome').hide();
            jQuery('#fb_login_status').html('Logging in...');
            jQuery('#fb_login_welcome').show();

            getUserDetails(false);
            jQuery('[class="container_bottom_newuser"]').remove();
          } else {
            if (typeof payPalOfferFreeFeatured !== 'undefined') {
              window.location.reload();
              return false;
            }
            if (result.url) {
              window.location.href = result.url;
            } else {
              window.location = '/dashboard/';
            }
          }
        } else {
          if (/Invalid username or password/i.test(result.reason)) {
            const errorTxt = T_('Invalid username or password!');
            if (jQuery('#fb_login_user').is(':visible')) {
              if (!bsPage) {
                addError(jQuery('#fb_login_user'), errorTxt);
              } else {
                jQuery('.link-account-error')
                  .text(errorTxt)
                  .show();
              }
            } else if (jQuery('#fb_link_passwd').is(':visible')) {
              if (!bsPage) {
                addError(jQuery('#fb_link_passwd'), errorTxt);
              } else {
                jQuery('.link-account-error')
                  .text(errorTxt)
                  .show();
              }
            }
          } else {
            const errorTxt = result.reason;
            if (!bsPage) {
              addError(jQuery('#fb_link_passwd'), errorTxt);
            } else {
              jQuery('.link-account-error')
                .text(errorTxt)
                .show();
            }
          }

          jQuery('.fb_submit_loading').hide();
          jQuery('#fbSignupBtn').show();
          jQuery('.fbLinkBtn').show();
          defreezeForm();
        }
        return false;
      },
    });
    freezeForm();
    jQuery(this)
      .hide()
      .next()
      .show();
    return false;
  });

  jQuery('#fbSignupBtn').click(function(e) {
    if (!validEmail) {
      return false;
    }

    if (!validUsername) {
      return false;
    }

    if (!allowSignup) {
      return false;
    }

    const url = '/users/facebook/onSignup.php';
    let isEmployer;
    if (isOnNotRedirectPage()) {
      isEmployer = '1';
    } else {
      isEmployer = '0';
    }
    if (jQuery('#fb_looking_to_hire').length !== 0) {
      if (!hasChosenLookingForOption()) {
        e.stopPropagation();
        return false;
      }
      if (jQuery('#fb_looking_to_hire').is(':checked')) {
        isEmployer = '1';
      } else {
        isEmployer = '0';
      }
    }
    const csrf_token = getCSRFToken();
    jQuery.ajax({
      type: 'POST',
      dataType: 'json',
      url,
      data:
        `goto_url=${openidGotoUrl}` +
        '&decode=1&action=register' +
        `&newusername=${jQuery('#fb_user').val()}` +
        `&currency=${jQuery('#fb_currency').val()}` +
        `&timezone=${jQuery('#fb_timezone').val()}` +
        `&email=${encodeURIComponent(jQuery('#fb_email_input').val())}` +
        `&isEmployer=${isEmployer}` +
        `&token=${fbtoken}` +
        `&page=${window.location.pathname}` +
        `&thm_session=${tagsSessionId}` +
        `&csrf_token=${csrf_token}`,
      success(result) {
        if (result.status == 'success') {
          if (window.location.pathname == '/signup') {
            // To the membership singup
            if (result.url) {
              window.location.href = result.url;
            } else {
              ABTest.getUserExperimentVariation(
                'FLT-T41092-freelancer-onboarding-v3',
                result.userId,
              ).then(variant => {
                if (variant === 'test') {
                  this.$window.location.href = '/new-freelancer';
                  return;
                }
                this.$window.location.href = '/sellers/skill-select.php';
              });
            }
          } else if (
            jQuery('.quick-hire-post-form').length > 0 &&
            jQuery('.quick-hire-post-form').is(':visible')
          ) {
            // directory inline hireme form
            jQuery('.quick-hire-post-form').trigger('welcomeFacebook', [
              true,
              getUserDetails,
            ]);
          } else if (isOnNotRedirectPage()) {
            jQuery('#fb_signup_welcome').hide();
            jQuery('#fb_login_status').html('Logging in...');
            jQuery('#fb_login_welcome').show();
            if (typeof onFacebookLoginCallback === 'function') {
              onFacebookLoginCallback();
            }
            getUserDetails(true);
            jQuery('[class="container_bottom_newuser"]').remove();
          } else if (result.url) {
            if (typeof payPalOfferFreeFeatured !== 'undefined') {
              window.location.reload();
              return false;
            }
            window.location.href = result.url;
          } else {
            ABTest.getUserExperimentVariation(
              'FLT-T41092-freelancer-onboarding-v3',
              result.userId,
            ).then(variant => {
              if (variant === 'test') {
                this.$window.location.href = '/new-freelancer';
                return;
              }
              this.$window.location.href = '/sellers/skill-select.php';
            });
          }
        } else {
          jQuery('.fb_submit_loading').hide();
          jQuery('#fbSignupBtn').show();
          jQuery('.fbLinkBtn').show();
          defreezeForm();
          alert(result.reason);
        }
        allowSignup = true;
        return false;
      },
    });
    freezeForm();
    jQuery(this)
      .hide()
      .next()
      .show();
    allowSignup = false;
    return false;
  });

  jQuery('#fb_user')
    .focusout(() => {
      prevUsernameCheckReq = checkUsernameExist(jQuery('#fb_user').val());
    })
    .keyup(event => {
      removeError(jQuery('#fb_user'), true);
      if (event.keyCode == 13) {
        jQuery('#fbSignupBtn').click();
      }
      prevUsernameCheckReq = checkUsernameExist(jQuery('#fb_user').val());
      if (!bsPage) {
        jQuery('#chk_username_exist').hide();
      }
      return false;
    });

  jQuery('#fb_email_input')
    .focusout(() => {
      checkEmailValid(jQuery('#fb_email_input').val());
    })
    .keyup(event => {
      removeError(jQuery('#fb_email_input'), true);
      if (event.keyCode == 13) {
        jQuery('#fbSignupBtn').click();
      }
      checkEmailValid(jQuery('#fb_email_input').val());
      if (!bsPage) {
        jQuery('#chk_valid_email').hide();
      }
      return false;
    });

  jQuery('#fb_link').submit(e => {
    e.preventDefault();
    jQuery('.fbLinkBtn').click();
  });

  jQuery('#fb_link_passwd').keyup(() => {
    removeError(jQuery('#fb_link_passwd'), true);
  });

  jQuery('#fb_login_user').keyup(() => {
    removeError(jQuery('#fb_login_user'), true);
  });

  jQuery('#fb_login_passwd').keyup(() => {
    removeError(jQuery('#fb_login_user'), true);
  });

  jQuery('#fb_forgot_password_btn').on('click', e => {
    e.preventDefault();
    jQuery('#fb_popup').hide();
    if (!jQuery('#default-modal-placeholder').length) {
      // element does not exist
      jQuery('#facebook-loginsignup-container').append(
        '<div id="default-modal-placeholder"></div>',
      );
    }
    const loginSignup = new LoginSignup({
      el: jQuery('#default-modal-placeholder'),
      loginClbk: false,
      employerSignupClbk: false,
      workerSignupClbk: false,
    });
    loginSignup.vent.trigger('show:recoverpassword');
  });
}
